import { VehicleColours } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehiclecolours';
import { VehicleOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoption';
import { VehicleOptionItem } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoptionitem';
import { exterior, hood, interiorFabric } from '../constants';
import { removeMandatoryOptionText } from '../resources';

export const useFinalisedOptions = (
  colours: VehicleColours,
  options: VehicleOption[]
) => {
  const getParent = (optionId: number) => {
    let parent;
    for (let i = 0; i < options.length; i++) {
      const p = options[i];
      parent = p.items.find(
        (f) => f.optionRules && f.optionRules.find((d) => d.id === optionId)
      );

      if (parent && parent.checked) {
        break;
      }
    }

    return parent;
  };

  const canRemoveOption = (option: VehicleOptionItem) => {
    if (option.disabled) {
      return false;
    }

    const parent = getParent(option.id);

    if (
      parent &&
      option.optionRules &&
      option.optionRules.find((f) => f.id === parent.id)
    ) {
      return true;
    }

    return !(parent && parent.checked);
  };

  const finalisedOptions = [
    ...colours.paint
      .filter((paint) => paint.checked)
      .map((element) => ({
        id: element.id,
        title: element.title,
        monthlyRentalCost: element.monthlyRentalCost,
        type: exterior,
        canRemove: false,
        optionRules: [],
        removeText: removeMandatoryOptionText,
      })),
    ...colours.trim
      .filter((trim) => trim.checked)
      .map((element) => ({
        id: element.id,
        title: element.title,
        monthlyRentalCost: element.monthlyRentalCost,
        type: interiorFabric,
        canRemove: false,
        optionRules: [],
        removeText: removeMandatoryOptionText,
      })),
    ...colours.hood
      .filter((f) => f.checked)
      .map((element) => ({
        id: element.id,
        title: element.title,
        monthlyRentalCost: element.monthlyRentalCost,
        type: hood,
        canRemove: false,
        optionRules: [],
        removeText: removeMandatoryOptionText,
      })),
    ...options
      .map((value) =>
        value.items.map((child) => Object.assign({ name: value.name }, child))
      )
      .reduce((l, n) => l.concat(n.filter((c) => c.checked)), [])
      .map((element) => ({
        id: element.id,
        title: element.label,
        monthlyRentalCost: element.monthlyCost,
        type: element.name,
        canRemove: canRemoveOption(element),
        optionRules: element.optionRules,
        removeText: null,
      })),
  ];

  return { finalisedOptions };
};
